module.exports = __webpack_public_path__ + "img/doorbell-yobi.afb660fb.png";